module.exports = __webpack_public_path__ + "img/ST.c9b4da93.png";